import ModalHubSFC from "./ModalHub.vue";
export { useModalHubStore } from "./use-modal-hub";
export const ModalHub = ModalHubSFC;
